import { render, staticRenderFns } from "./ongoing-call-box.vue?vue&type=template&id=68652461&scoped=true"
import script from "./ongoing-call-box.vue?vue&type=script&lang=js"
export * from "./ongoing-call-box.vue?vue&type=script&lang=js"
import style0 from "./ongoing-call-box.vue?vue&type=style&index=0&id=68652461&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68652461",
  null
  
)

export default component.exports